<div class="messages">
    @for(m of messages; track m.id; let last = $last) {
    <div class="message">
        <span class="from">{{m.from}}</span>
        <div class="body">

            <span class="text">{{m.previewText}}</span>
            <!--<span class="date">{{m.dateSent}}</span>-->
        </div>
    </div>
    }
</div>